import './index.scss'
import '../../assets/styles/language.css'
import '../../assets/scripts/trp-frontend-language-switcher.js'
import '../../assets/scripts/trp-language-cookie.js'


$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$("header .nav li").hover(function(){
    $("header .nav li .child-nav").stop().slideUp()
    $(this).find(".child-nav").stop().slideDown()
}
,function(){
    $(this).find(".child-nav").stop().slideUp()
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
 